import React from 'react';
import ReactMarkdown from 'react-markdown';
import LoadingSpinner from './LoadingSpinner';
import Quiz from './Quiz';

function ExplanationOutput({ 
  explanation, 
  loading, 
  featureOutput, 
  featureLoading, 
  activeFeature,
  activeContent
}) {
  const renderFeatureOutput = () => {
    if (featureLoading) return <LoadingSpinner message="Generating content... It takes a few minutes..." />;
    
    if (!featureOutput) return <p className="placeholder">Additional content will appear here...</p>;
    
    switch (activeFeature) {
      case 'metaphor':
        return (
          <div className="feature-metaphor">
            {featureOutput.map((metaphor, index) => (
              <div key={index} className="metaphor-card">
                <h5>{metaphor.title}</h5>
                <p>{metaphor.description}</p>
              </div>
            ))}
          </div>
        );
      
      case 'quiz':
        return <Quiz questions={featureOutput} />;
      
      case 'learningPath':
        return (
          <div className="learning-path">

            {featureOutput.map((step) => (
              <div key={step.step} className="path-step">
                <div className="step-number">{step.step}</div>
                <div className="step-content">
                  <h5>{step.title}</h5>
                  <p>{step.description}</p>
                  {step.resources && (
                    <div className="resources">
                      <p>Resources:</p>
                      <ul>
                        {Array.isArray(step.resources) ? (
                          step.resources.map((resource, index) => (
                            <li key={index}>
                              <a href={resource.link} target="_blank" rel="noopener noreferrer">
                                {resource.name}
                              </a>
                            </li>
                          ))
                        ) : (
                          <li>{step.resources}</li>
                        )}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        );
      
      default:
        return null;
    }
  };

  const renderContent = () => {
    if (activeContent === 'feature') {
      if (featureLoading) {
        return <LoadingSpinner message="Generating content... It takes a few minutes..." />;
      }
      
      if (featureOutput && activeFeature) {
        return renderFeatureOutput();
      }
    } else { // activeContent === 'explanation'
      if (loading) {
        return <LoadingSpinner message="Generating explanation... It takes a few minutes..." />;
      }
      
      if (explanation) {
        return (
          <div className="markdown-content">
            <ReactMarkdown>{explanation}</ReactMarkdown>
          </div>
        );
      }
    }
    
    return <p className="placeholder">Content will appear here...</p>;
  };

  return (
    <div className="output-section">
      <h3>Results:</h3>
      <div id="explanation-output" className="explanation">
        {renderContent()}
      </div>
    </div>
  );
}

export default ExplanationOutput;